import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { offerApi } from "../../../services/offerApi";
import SlideCanvas from "./SlideCanvas";
import { waitForAssets } from "./assets";
import { H, W } from "./theme";

// Une page par slide, au format exact du canevas : « Enregistrer au format PDF »
// du navigateur produit le PDF (secours quand le serveur ne peut pas l'imprimer ;
// sinon le serveur imprime la même mise en page, mode « print » de ProposalRender).
export const PRINT_CSS = `
@page { size: ${W}px ${H}px; margin: 0; }
html, body { margin: 0; padding: 0; background: #e2e8f0; }
.offer-print-page { width: ${W}px; height: ${H}px; margin: 24px auto; box-shadow: 0 1px 6px rgba(15, 23, 42, 0.15);
  break-after: page; page-break-after: always; overflow: hidden; }
* { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
@media print {
  html, body { background: #ffffff; }
  .offer-print-page { margin: 0; box-shadow: none; }
  .offer-print-toolbar { display: none !important; }
}
`;

// Comme le PDF du serveur (pdf_filename) : Innowide_P-2026-117_v1_Flameco-Capteur-sans-fil-dans-tuyauterie.
const filePart = (text, limit) => {
  const kept = [];
  for (const word of String(text || "").match(/[^\s\\/:*?"<>|–—-]+/g) || []) {
    if (limit && kept.length && [...kept, word].join("-").length > limit) break;
    kept.push(word);
  }
  return kept.join("-");
};
const fileName = (data) => {
  const { proposal, content } = data;
  const parts = ["Innowide", filePart(content.meta?.reference), filePart(content.meta?.version), filePart(proposal.title, 40)];
  return parts.filter(Boolean).join("_").slice(0, 120);
};

const ProposalPrint = () => {
  const { proposalId } = useParams();
  const [params] = useSearchParams();
  const revisionId = params.get("revision") || undefined;
  // ?apercu=1 : afficher les pages sans ouvrir la boîte d'impression.
  const autoPrint = !params.get("apercu");
  const [data, setData] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    offerApi.proposal(Number(proposalId), revisionId).then(setData).catch((err) => setError(err.message));
  }, [proposalId, revisionId]);

  useEffect(() => {
    if (!data) return undefined;
    const previousTitle = document.title;
    document.title = fileName(data);
    let cancelled = false;
    // Laisser les images se charger avant d'ouvrir la boîte d'impression.
    const timer = setTimeout(async () => {
      await waitForAssets();
      await document.fonts?.ready;
      if (!cancelled && autoPrint) window.print();
    }, 400);
    return () => {
      cancelled = true;
      clearTimeout(timer);
      document.title = previousTitle;
    };
  }, [data, autoPrint]);

  if (error) return <p style={{ padding: 24, fontFamily: "Arial" }}>{error}</p>;
  if (!data) return <p style={{ padding: 24, fontFamily: "Arial" }}>Préparation du PDF…</p>;

  let page = 0;
  return (
    <div>
      <style>{PRINT_CSS}</style>
      <div className="offer-print-toolbar" style={{ fontFamily: "Arial", textAlign: "center", padding: "16px 16px 0", color: "#334155" }}>
        <button type="button" onClick={() => window.print()}
          style={{ padding: "8px 16px", borderRadius: 999, border: "none", background: "#0f172a", color: "#fff", cursor: "pointer" }}>
          Enregistrer en PDF
        </button>
        <p style={{ fontSize: 13, marginTop: 8 }}>
          Destination « Enregistrer au format PDF », marges « Aucune », graphiques d'arrière-plan activés.
        </p>
      </div>
      {data.content.slides.filter((slide) => !slide.hidden).map((slide) => {
        page += 1;
        return (
          <div key={slide.id} className="offer-print-page">
            <SlideCanvas slide={slide} meta={data.content.meta} estimate={data.estimate} page={page} embeds={data.embeds}
              deckTitle={data.proposal?.title} />
          </div>
        );
      })}
    </div>
  );
};

export default ProposalPrint;
